import app from 'flarum/forum/app';
import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';
import Stream from 'flarum/utils/Stream';
import Select from 'flarum/common/components/Select';

import UploadComponent from '../UploadComponent';
import setInputError from "../../common/util/setInputError";
import showAlert from '../../common/util/showAlert';
import SiteInfoRequestSuccessModal from './SiteInfoRequestSuccessModal';
import CaptchaComponent from '../CaptchaComponent';
import UserSubmitModal from './UserSubmitModal';
import SignUpModal from 'flarum/forum/components/SignUpModal';

export default class SiteInfoYouKePlanModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
    this.loading = false;
    this.item = {};
    this.item.option_zsxm = Stream("");
    this.item.option_zsxm_title = Stream(0);
    this.item.option_lxdh = Stream("");
    this.item.option_lxdh_checked = Stream(0);
    this.item.option_lxdh_wx_value = Stream("");
    this.item.option_lxdh_wx_value_disabled = Stream(true);
    this.item.option_yszs = Stream("");
    this.item.option_yklx = Stream("0");
    this.item.option_mpzp = Stream([]);
    this.u2diCaptcha = Stream("");
    this.ykjhEnabled = app.forum.attribute("ykjhEnabled");

    this.wrapData = this.attrs.wrapData || null;
    this.returnModal = "";

    if(this.wrapData){
      if(this.wrapData.returnModal==="UserSubmitModal"){
        this.returnModal = UserSubmitModal;
      }else if(this.wrapData.returnModal==="SignUpModal"){
        this.returnModal = SignUpModal;
      }
    }

  }

  onremove(){
    const _this = this;

    if(_this.returnModal!==""){
      setTimeout(function(){
        app.modal.show(_this.returnModal);
      },100);
    }
  }

  className() {
    return 'Modal--large';
  }

  title() {
    return (
      <span style="font-size:24px;font-weight:bold">
        优客计划
      </span>
    );
  }

  onready() {
    const _this = this;
    $('input[type=radio][name=option_lxdh_checked]').on('change', function() {
      let value = parseInt($(this).val());
      _this.item.option_lxdh_checked(value);
      _this.item.option_lxdh_wx_value_disabled(value===0);
      _this.item.option_lxdh_wx_value(value===1?"":_this.item.option_lxdh());
      m.redraw();
    });

    $('input[type=radio][name=option_zsxm]').on('change', function() {
      _this.item.option_zsxm_title(parseInt($(this).val()));
    });

    let height = 360;
    let width = height*16/9;
    let spaceWidth = $(".Modal-body").width();

    if(width>spaceWidth){
      width = spaceWidth;
      height = width*9/16;
    }

    $("#u2diIframeVideo").css("width",width)
    $("#u2diIframeVideo").css("height",height)
  }

  content() {

    return (
      <div className="Modal-body YouKePlanModal">
        <div className="Form" style="color:var(--text-color)">
          <p style="text-align: center;">
            <iframe id="u2diIframeVideo" style="margin-bottom:20px;" src="//player.bilibili.com/player.html?aid=615509433&bvid=BV1Gh4y1u7fY&cid=1197214848&page=1&autoplay=1" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
          </p>
          <p style="font-size: 18px;font-weight:bold;">
            欢迎您参与「优土地」平台的优客计划，这是一项让您拥有的资源变现的计划。
          </p>
          <p style="font-size: 16px;color:gray;">
            本计划招募两类资源方，如果您满足并同意以下条件，请填写下方表单加入我们：
          </p>
          <div style="padding-bottom:20px;font-size: 14px;color:gray;">
            <p>资源型优客：拥有一手土地信息的中介方，最好自己有车。请注意，如果加入优客计划，您发布的土地信息必须是您所掌握的第一手信息，您与地主方是直接对接的，若未来在本平台上，您发布了任何一条被证实不是第一手的土地信息，您的账号将被封禁。</p>
            <p>人脉型优客：现状为公司中层管理至公司老板各岗位。您拥有大量第一手的人脉资源，加入我们平台成为优客后，您可以通过参与其他人发布的土地信息分销，并在促成交易中发挥了重要的作用。</p>
            <p style="font-size: 12px;">注：若优客账号被封禁，您也将被记录在「居间吧｜jujianba.com」的失信名单中。</p>
          </div>

          <p style="font-size: 18px;font-weight:bold;">
            分成比例：
          </p>
          <div style="padding-bottom:20px;font-size: 14px;color:gray;">
            <p>情况一（优客至优客），若成单，居间收入将按照35%+30%+35%的比例进行分配。其中的30%是「优土地」平台的分成，两边的35%为双方优客的收入比例。</p>
            <p>情况二（优客至地主），本平台也将收悉部分地主直接发布的土地信息，若优客加入该类土地信息的分销，将按照50%+50%的比例进行分配，其中50%为「优土地」平台的分成，50%为分销优客的收入。</p>
          </div>

          <p style="font-size: 18px;font-weight:bold;">
            账号期限：
          </p>
          <div style="padding-bottom:20px;font-size: 14px;color:gray;">
            报名通过后，您将收到优客的注册码，体验期限为一年，到期后将不能进行任何操作，续期政策确定后，将通知到每位优客。
          </div>

          <p style="font-size: 18px;font-weight:bold;">
            注意事项：
          </p>
          <div style="padding-bottom:20px;font-size: 14px;color:gray;">
            <p>1，您的个人信息将写入每宗土地交易的居间协议中，所以在报名及注册过程中需提供完整准确的个人信息，且写入后不可修改，若提供不实信息导致的任何损失由您自行承担。</p>
            <p>2，您需要明白中间人行业本就存在的跳单风险，若发生了跳单的情况，我们平台也将损失该部分收入，本平台不承担跳单导致的任何责任。</p>
            <p>3，为了达成某宗土地的交易，可能产生的任何前后期费用由优客自行承担，本平台不提供任何报销。交易成功后，到达优客的收入请自行主动报税，优客逃税漏税所导致的任何后果与本平台无关。</p>        
          </div>

          <p style="font-weight:bold;font-size:18px;">
            报名参与：<span style="color: red; font-size: 12px; font-weight: 400;">（信息提交后，将进行人工审核）</span>
          </p>

          <p style="margin-bottom: 20px;">
            <div style="padding-top: 5px;" className="u2diUserSubmitCategoryItems">
              <div className="u2diUserSubmitCategoryItemName">
                {app.translator.trans('ziven-u2di.forum.user-submission-category-item-yklx')}
              </div>
              <div className="u2diUserSubmitCategoryItemOptions">
                <Select className="u2diDataSelectList" value={this.item.option_yklx()}
                  disabled={this.loading || this.ykjhEnabled===false}
                  options={{
                    "0":app.translator.trans('ziven-u2di.forum.option-yklx-0'),
                    "1":app.translator.trans('ziven-u2di.forum.option-yklx-1'),
                    "2":app.translator.trans('ziven-u2di.forum.option-yklx-2'),
                  }}
                  onchange={(e) => { 
                    this.item.option_yklx(e); 

                    if(e==0){
                      this.item.option_mpzp = Stream([]);
                    }
                  }}
                />
              </div>
            </div>

            <div style="padding-top: 5px;" className="u2diUserSubmitCategoryItems">
              <div className="u2diUserSubmitCategoryItemName">
                {app.translator.trans('ziven-u2di.forum.user-submission-category-item-zsxm')}
              </div>
              <div className="u2diUserSubmitCategoryItemOptions">
                <div className="u2diOptionsAdjustItem">
                  <input id="option_zsxm" disabled={this.loading || this.ykjhEnabled===false} required className="FormControl u2diUserSubmitCategoryItemInput" type="text" bidi={this.item.option_zsxm} />
                </div>
                <div className="u2diOptionsAdjustItem u2diOptionsMarginItem1">
                  <input disabled={this.loading || this.ykjhEnabled===false} className="u2diUserSubmitCategoryItemRadio" id="zsxm_title0" type="radio" name="option_zsxm" value="0" checked={this.item.option_zsxm_title()==0?"checked":""} /><label style="margin-left: 5px;" for="zsxm_title0">{app.translator.trans('ziven-u2di.forum.option-zsxm-0')}</label>
                  <input disabled={this.loading || this.ykjhEnabled===false} className="u2diUserSubmitCategoryItemRadio" id="zsxm_title1" type="radio" name="option_zsxm" value="1" checked={this.item.option_zsxm_title()==1?"checked":""} /><label style="margin-left: 5px;" for="zsxm_title1">{app.translator.trans('ziven-u2di.forum.option-zsxm-1')}</label>
                </div>
              </div>
            </div>

            {this.item.option_zsxm()!=="" && (this.item.option_zsxm().length<2 || this.item.option_zsxm().length>4) && (
              <div className="u2diUserSubmitCategoryItems ">
                <div className="u2diUserSubmitCategoryItemName">
                </div>
                <div style="color:var(--alert-error-bg)" className="u2diUserSubmitCategoryItemOptions">
                  真实姓名长度需要在2-4个字之间
                </div>
              </div>
            )}

            <div style="padding-top: 5px;" className="u2diUserSubmitCategoryItems">
              <div className="u2diUserSubmitCategoryItemName">
                {app.translator.trans('ziven-u2di.forum.user-submission-category-item-lxdh')}
              </div>
              <div className="u2diUserSubmitCategoryItemOptions">
                <div className="u2diOptionsAdjustItem">
                  <input id="option_lxdh" maxlength="11" disabled={this.loading || this.ykjhEnabled===false} required className="FormControl u2diUserSubmitCategoryItemInput" type="text" bidi={this.item.option_lxdh} />
                </div>
                <div className="u2diOptionsAdjustItem u2diOptionsMarginItem1">
                  <input disabled={this.loading || this.ykjhEnabled===false} className="u2diUserSubmitCategoryItemRadio" id="lxdh_wx0" type="radio" name="option_lxdh_checked" value="0" checked={this.item.option_lxdh_checked()==0?"checked":""} /><label style="margin-left: 5px;" for="lxdh_wx0">{app.translator.trans('ziven-u2di.forum.option-lxdh-wx-0')}</label>
                </div>
                <div className="u2diOptionsAdjustItem u2diOptionsMarginItem1" style="padding-top: 0px;">
                  <input disabled={this.loading || this.ykjhEnabled===false} className="u2diUserSubmitCategoryItemRadio" id="lxdh_wx1" type="radio" name="option_lxdh_checked" value="1" checked={this.item.option_lxdh_checked()==1?"checked":""} /><label style="margin-left: 5px;" for="lxdh_wx1">{app.translator.trans('ziven-u2di.forum.option-lxdh-wx-1')}</label>
                  <input id="option_lxdh_wx_value" maxlength="11" disabled={this.loading || this.ykjhEnabled===false || this.item.option_lxdh_wx_value_disabled()} required style="margin-left: 15px;" className="FormControl u2diUserSubmitCategoryItemInput" type="text" bidi={this.item.option_lxdh_wx_value} />
                 </div>
              </div>
            </div>

            <div style="padding-top: 5px;align-items: flex-start;" className="u2diUserSubmitCategoryItems">
              <div className="u2diUserSubmitCategoryItemName">
                {app.translator.trans('ziven-u2di.forum.user-submission-category-item-yszs')}
              </div>
              <div className="u2diUserSubmitCategoryItemOptions">
                <textarea id="option_yszs" disabled={this.loading || this.ykjhEnabled===false} style="height: 80px;" maxlength="2000" required className="FormControl u2diUserSubmitItemInput" bidi={this.item.option_yszs} />
              </div>
            </div>

            {this.item.option_yklx()!=0 && (
              <div style="padding-top: 5px;padding-bottom: 15px;align-items: flex-start;" className="u2diUserSubmitCategoryItems">
                <div className="u2diUserSubmitCategoryItemName">
                  {app.translator.trans('ziven-u2di.forum.user-submission-category-item-mpzp')}
                </div>
                <div className="u2diUserSubmitCategoryItemOptions">
                  <UploadComponent disabled={this.loading || this.ykjhEnabled===false} uploadType="option_mpzp" uploadLimit="2" uploadTarget={this.item.option_mpzp} uploadCallback={function(result,option_target){
                      
                  }} />
                </div>
              </div>
            )}

            <div style="padding-top: 5px;" className="u2diUserSubmitCategoryItems">
              <div className="u2diUserSubmitCategoryItemName">
                {app.translator.trans('ziven-u2di.forum.captcha-validation')}
              </div>
              <div style="display: flex;" className="u2diUserSubmitCategoryItemOptions">
                <input id="u2diCaptcha" disabled={this.loading || this.ykjhEnabled===false} required className="FormControl u2diUserSubmitCategoryItemInput" type="input" maxlength="4" bidi={this.u2diCaptcha} />
                <CaptchaComponent />
              </div>
            </div>
          </p>

          {this.ykjhEnabled===false && (
            <p style="color:red;text-align:center">
              优客计划暂停申请
            </p>
          )}

          <div style="text-align:center;margin-top: 30px;">
            {Button.component({
                className: 'Button Button--primary',
                disabled: this.loading || this.ykjhEnabled===false,
                onclick: (e) => {
                  this.submitData(e);
                }
              },
              app.translator.trans('ziven-u2di.lib.submit')
            )}&nbsp;
            {Button.component({
                className: 'Button U2DiButton--gray',
                disabled: this.loading,
                onclick: () => {
                  this.hide();
                }
              },
              app.translator.trans('ziven-u2di.lib.cancel')
            )}
          </div>
        </div>
      </div>
    );
  }

  checkSubmitData(){
    //
    const wrapData = this.item;
    let isValid = true;

    for(let index in wrapData){
      if(typeof(wrapData[index])!=="function"){
        continue;
      }

      if((wrapData[index]()).length===0 && $("#"+index).length>0 && $("#"+index).prop('disabled')!==true){
        setInputError("#"+index,isValid);
        isValid = false;
      }
    }

    if((this.item.option_zsxm().length)<2 || (this.item.option_zsxm().length)>4){
      setInputError("#option_zsxm",isValid);
      isValid = false;
    }

    return isValid;
  }

  submitData(e) {
    e.preventDefault();

    if(this.checkSubmitData()===false){
      showAlert(app.translator.trans('ziven-u2di.forum.error-input-empty'));
      return;
    }

    this.loading = true;

    const submitData = {
      type: "ykjh",
      u2diCaptcha:this.u2diCaptcha(),
      data: JSON.stringify({
        option_yklx:this.item.option_yklx(),
        option_zsxm:this.item.option_zsxm(),
        option_zsxm_title:this.item.option_zsxm_title(),
        option_lxdh:this.item.option_lxdh(),
        option_lxdh_wx_value:this.item.option_lxdh_checked()===0?this.item.option_lxdh():this.item.option_lxdh_wx_value(),
        option_yszs:this.item.option_yszs(),
        option_mpzp:this.item.option_mpzp(),
      }),
    };

    app.store
      .createRecord("u2diRequest")
      .save(submitData)
      .then((returnData) => {
          app.modal.show(SiteInfoRequestSuccessModal,{requestType:submitData.type});
        }
      )
      .catch((e) => {
        this.loading = false;
        $(".u2diCaptcheImage").click();
      });

  }
}
